import React, { useState } from "react";
import alfredoIcon from "../../assets/alfredo-central-icon.png";
import MessageBox from "../../components/MessageBox";
import { useNavigate } from "react-router-dom";
import { useCombinedStore } from "../../store";
import * as AlfredoStyles from "../../styles/global/global";

interface LoginPageProps {
  children: React.ReactElement;
}

const LoginPage: React.FC<LoginPageProps> = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { selectedSection } = useCombinedStore((state) => {
    return {
      selectedSection: state.selectedSectionZustand || "Email",
    };
  });

  const handleLogin = () => {
    setIsLoading(true);
  };

  return (
    <AlfredoStyles.SignPageContainer>
      <MessageBox />
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
      <AlfredoStyles.SignUp>
        <AlfredoStyles.SignUpText>
          Sua loja ainda não está no Alfredo?
        </AlfredoStyles.SignUpText>
        <AlfredoStyles.SignUpButton onClick={() => navigate("/register")}>
          <i className="material-icon">login</i>CADASTRAR AGORA
        </AlfredoStyles.SignUpButton>
      </AlfredoStyles.SignUp>
      <AlfredoStyles.Left isLoading={isLoading}>
        <AlfredoStyles.Logo
          src={alfredoIcon}
          alt="Alfredo Icon"
          $selectedSession={selectedSection}
          $isLoading={isLoading}
        />
        <AlfredoStyles.SignPageTitle $isLoading={isLoading}>
          Bem vindo ao Alfredo
        </AlfredoStyles.SignPageTitle>
        <AlfredoStyles.DescriptionText>
          A Inteligência Artificial das Lojas Físicas.
        </AlfredoStyles.DescriptionText>
      </AlfredoStyles.Left>
      {!isLoading && (
        <AlfredoStyles.Right>
          <AlfredoStyles.ModalContent>
            {React.cloneElement(children, { setIsLoading: handleLogin })}
          </AlfredoStyles.ModalContent>
        </AlfredoStyles.Right>
      )}
    </AlfredoStyles.SignPageContainer>
  );
};

export default LoginPage;
